/*
 * @Author: huguantao1@jd.com
 * @Date: 2025-06-09 22:27:22
 * @LastEditors: huguantao1@jd.com
 * @LastEditTime: 2025-07-01 14:00:52
 * @FilePath: /intl-pc-jdi-website-ssr/src/utils/multiSite/const.ts
 * @Description: 多域名相关的静态变量，用于域名切换、关键信息存储等
 */

export const defaultJDICountry = "GB";
export const DefaultHost = "www.joybuy.com";
export const DefaultBetaHost = "beta.joybuy.com";
export const DefaultProtocol = "https:";

export const siteCodeMap = {
  '.nl': "NL-Site",
  '.co.de': "DE-Site",
  '.fr': "FR-Site",
  '.com': "UK-Site",
};
  
export const colorApiMap = {
  '.nl': 'https://color-api.joybuy.nl',
  '.co.de': 'https://color-api.joybuy.co.de',
  '.fr': 'https://color-api.joybuy.fr',
  '.com': 'https://color-api.joybuy.com',
};

export const multiDomainMap = {
  NL: 'https://www.joybuy.nl',
  DE: 'https://www.joybuy.co.de',
  FR: 'https://www.joybuy.fr',
  default: 'https://www.joybuy.com',
};

export const colorApiBetaMap = {
  '.nl': 'https://beta-color-api.joybuy.nl',
  '.co.de': 'https://beta-color-api.joybuy.co.de',
  '.fr': 'https://beta-color-api.joybuy.fr',
  '.com': 'https://beta-color-api.joybuy.com',
};

export const multiDomainBetaMap = {
  NL: 'https://beta.joybuy.nl',
  DE: 'https://beta.joybuy.co.de',
  FR: 'https://beta.joybuy.fr',
  default: 'https://beta.joybuy.com',
};

export const NLSiteCountries = ['NL', 'BE', 'LU'];
export const FRSiteCountries = ['FR'];
export const DESiteCountries = [
    'DE',
    'IE',
    'EE',
    'AT',
    'BG',
    'PL',
    'DK',
    'FI',
    'CZ',
    'HR',
    'LV',
    'LT',
    'RO',
    'PT',
    'SE',
    'CH',
    'SI',
    'ES',
    'GR',
    'HU',
    'IT'
];
export const multiDomainCountryEnum = [...NLSiteCountries, ...FRSiteCountries, ...DESiteCountries];
